var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ib-col flex" },
    [
      _c("div", { staticClass: "ib-row" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("div", { staticClass: "ib-col insety-16" }, [
            _c(
              "label",
              { staticClass: "bold bond-title fg70" },
              [
                _vm._v("Category: "),
                _c("ib-dropdown", {
                  staticClass: "inset-8",
                  attrs: {
                    width: "20ch",
                    name: "categoryselect",
                    data: _vm.categories,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.onChange()
                    },
                  },
                  model: {
                    value: _vm.categoryValue,
                    callback: function ($$v) {
                      _vm.categoryValue = $$v
                    },
                    expression: "categoryValue",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "ib-table-basic",
        {
          ref: "table",
          staticClass: "ib-row shrink fs7 fg70 insety-16 event-border",
          attrs: {
            data: _vm.events,
            spacing: "huge",
            wrap: "",
            rowstripe: "",
            rowborder: "",
            colborder: "",
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function (row) {
                return [
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.dateFormat(row.date)))]),
                  ]),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.getRegion(row.region)))]),
                  ]),
                  _c("td", [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(_vm._s(row.subject) + " "),
                      _c("br"),
                    ]),
                    _c("span", { staticClass: "pre-wrap" }, [
                      _vm._v(_vm._s(row.description)),
                    ]),
                  ]),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.getCategory(row.category)))]),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "ib-table-col",
            {
              staticClass: "event-header-border-right",
              attrs: { width: "10ch" },
            },
            [_vm._v(_vm._s(_vm.$t("date_time")))]
          ),
          _c(
            "ib-table-col",
            {
              staticClass: "event-header-border-right",
              attrs: { width: "10ch" },
            },
            [_vm._v(_vm._s(_vm.$t("region")))]
          ),
          _c(
            "ib-table-col",
            {
              staticClass: "event-header-border-right",
              attrs: { width: "32ch" },
            },
            [_vm._v(_vm._s(_vm.$t("event")))]
          ),
          _c(
            "ib-table-col",
            {
              staticClass: "event-header-border-right",
              attrs: { width: "10ch" },
            },
            [_vm._v(_vm._s(_vm.$t("category")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }